import { IconButton } from '@monorepo/shared-lib';
import type { CSSProperties } from 'react';
import styled from 'styled-components';

/** Toolbar cog icon grey (matches entity transactions / activity log icons). */
export const CUSTOMISE_COLUMNS_ICON_COLOR = 'var(--color-text-muted, #5a6a6a)';

export const CUSTOMISE_COLUMNS_ICON_FONT_SIZE = 14;

/** Icon-only customise columns cog — 32×32, shared across tables and entity pages. */
export const customiseColumnsIconButtonStyle = (
  active = false
): CSSProperties => ({
  height: '32px',
  width: 32,
  minWidth: 32,
  backgroundColor: active
    ? 'var(--color-layout-bg, #e9f6f7)'
    : 'var(--color-surface-raised, #FFFFFF)',
  border: `2px solid ${active ? 'var(--color-primary, #41aaaf)' : 'var(--color-border, #dbeae3)'}`,
  borderRadius: '10px',
  boxShadow: '0px 0px 10px 0px #0000000d',
  color: 'var(--color-text-dark, #042a2a)',
  fontFamily: 'Inter, sans-serif',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const CustomiseColumnsIconButton = styled(IconButton)`
  font-family: Inter, sans-serif;

  .ant-btn-icon .anticon,
  .anticon {
    color: ${CUSTOMISE_COLUMNS_ICON_COLOR} !important;
  }

  &:hover:not(:disabled) .ant-btn-icon .anticon,
  &:hover:not(:disabled) .anticon {
    color: ${CUSTOMISE_COLUMNS_ICON_COLOR} !important;
  }
`;
